export enum ContactPathsEnum {
  contactPage = '/contact',
}
